/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    UpdateUserSettingsValues,
    UserId,
    UserSettingsView,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getUserSettingsUserId = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserSettingsView>> => {
    return axios.get(`/api/user-settings/${userId}`, options);
};

export const getGetUserSettingsUserIdQueryKey = (userId: UserId) => {
    return [`/api/user-settings/${userId}`] as const;
};

export const getGetUserSettingsUserIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUserSettingsUserIdQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUserSettingsUserId>>
    > = ({ signal }) =>
        getUserSettingsUserId(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUserSettingsUserId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserSettingsUserIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserSettingsUserId>>
>;
export type GetUserSettingsUserIdQueryError = AxiosError<unknown>;

export function useGetUserSettingsUserId<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserSettingsUserId>>,
                    TError,
                    Awaited<ReturnType<typeof getUserSettingsUserId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserSettingsUserId<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUserSettingsUserId>>,
                    TError,
                    Awaited<ReturnType<typeof getUserSettingsUserId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserSettingsUserId<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserSettingsUserId<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserSettingsUserIdQueryOptions(userId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUserSettingsUserIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUserSettingsUserIdQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUserSettingsUserId>>
    > = ({ signal }) =>
        getUserSettingsUserId(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserSettingsUserId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserSettingsUserIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserSettingsUserId>>
>;
export type GetUserSettingsUserIdSuspenseQueryError = AxiosError<unknown>;

export function useGetUserSettingsUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserSettingsUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserSettingsUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserSettingsUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUserSettingsUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUserSettingsUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUserSettingsUserIdSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUserSettingsUserId = (
    userId: UserId,
    updateUserSettingsValues: UpdateUserSettingsValues,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserSettingsView>> => {
    return axios.patch(
        `/api/user-settings/${userId}`,
        updateUserSettingsValues,
        options
    );
};

export const getPatchUserSettingsUserIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUserSettingsUserId>>,
        TError,
        { userId: UserId; data: UpdateUserSettingsValues },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUserSettingsUserId>>,
    TError,
    { userId: UserId; data: UpdateUserSettingsValues },
    TContext
> => {
    const mutationKey = ["patchUserSettingsUserId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUserSettingsUserId>>,
        { userId: UserId; data: UpdateUserSettingsValues }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUserSettingsUserId(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUserSettingsUserIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUserSettingsUserId>>
>;
export type PatchUserSettingsUserIdMutationBody = UpdateUserSettingsValues;
export type PatchUserSettingsUserIdMutationError = AxiosError<unknown>;

export const usePatchUserSettingsUserId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUserSettingsUserId>>,
            TError,
            { userId: UserId; data: UpdateUserSettingsValues },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUserSettingsUserId>>,
    TError,
    { userId: UserId; data: UpdateUserSettingsValues },
    TContext
> => {
    return useMutation(
        getPatchUserSettingsUserIdMutationOptions(options),
        queryClient
    );
};
